export default "__VITE_ASSET__BpFGSA_p__"